export const environment = {
  name: 'dev',
  production: false,
  instrumentationKey: "",
  recordDetailsEndpoint: '',
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: "02e5f9b7-7838-4472-8f06-c4063fb487ce",
  baseUrl: "https://sdsint-sds-web-dev-v1.azurewebsites.net",         // ← Dev frontend deployed
  apiUrl: "https://sdsint-sds-web-dev.azurewebsites.net",             // ← Dev API backend
  ApiKey: "",
  environment: "development",
  redirectUri: "https://sdsint-sds-web-dev-v1.azurewebsites.net/",    // ← MSAL redirect for deployed dev
};
